import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const RotateClockwise = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="rotate clockwise icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 8.98823C10 9.88782 11.0862 10.3383 11.7215 9.70223L15.7046 5.714C16.0985 5.31967 16.0985 4.68033 15.7046 4.286L11.7215 0.297772C11.0862 -0.338332 10 0.112182 10 1.01177L10 3.5H7.5C6.01215 3.5 4.64986 4.22882 3.68934 5.18934C2.72882 6.14986 2 7.51215 2 9V13C2 13.8284 2.67157 14.5 3.5 14.5C4.32843 14.5 5 13.8284 5 13V9C5 8.48785 5.27118 7.85014 5.81066 7.31066C6.35014 6.77118 6.98785 6.5 7.5 6.5H10L10 8.98823ZM12 12C10.8954 12 10 12.8954 10 14V22C10 23.1046 10.8954 24 12 24H20C21.1046 24 22 23.1046 22 22V14C22 12.8954 21.1046 12 20 12H12Z"
    />
  </svg>
)
